import axios from "axios";

//  var token = sessionStorage.getItem("Authorization") ? sessionStorage.getItem("Authorization" ): null;
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/vnd.api+json",
  },
});

export const authQuimera = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/vnd.api+json",
  },
});

export const authAPI = axios.create({
  baseURL: process.env.REACT_APP_AUTH_URL,
  headers: {
    "Content-Type": "application/vnd.api+json",
  },
});

export default instance;



// WEBPACK FOOTER //
// ./src/services/axios.js